import { BrowserRouter } from 'react-router-dom';
import LoadingPage from '@/app/loadingPage/loadingPage';
import AuthenticationGate from '@/app/authenticationGate/authenticationGate';
import Main from '@/app/layouts/Main';
import useApp from '@/app/useApp';

/**
 * Composes the application root from the loading page, authentication gate, router and shell. Runs useApp for its startup side effects and hands BrowserRouter an empty getUserConfirmation so the browser's own navigation prompt is suppressed in favour of the in-app unsaved-changes modal.
 *
 * @returns The rendered application tree.
 */
const App = () => {
  useApp();

  return (
    <>
      <LoadingPage />
      <AuthenticationGate>
        <BrowserRouter
          getUserConfirmation={() => {
            // For checking data change in main page
            // Empty callback to block the default browser prompt
          }}
        >
          <Main />
        </BrowserRouter>
      </AuthenticationGate>
    </>
  );
};

export default App;
